export default "__VITE_ASSET__CYi_Jx$3__"